import {useState} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

import LoadListListItemReelInspection from './LoadListListItemReelInspection';
import LoadListListItemReelLock from './LoadListListItemReelLock';
import LoadListListItemReelTypeDetail from './LoadListListItemReelTypeDetail';


export default function LoadListListItemReel(props){
    //console.debug("RTS Break LoadListListItemReel");

    const [showReelTypeModal, setShowReelTypeModal] = useState(false);

    const formatObj = new Intl.DateTimeFormat("en-US");
                   

    function handleClick(e){
        setShowReelTypeModal(true);
    }

    // function showDeferral(){
    //     if(props.data.deferralPeriod > 0 && props.data.status < 100){
    //         return true;
    //     }   
    //     else{
    //         return false;
    //     }
    // }

    return (
    <>
        <Dialog open={showReelTypeModal} onClose={()=>{setShowReelTypeModal(false);}} fullWidth={true} maxWidth="md">
            <DialogTitle>{props.data.reelTypeName}</DialogTitle>
            <DialogContent>
                <LoadListListItemReelTypeDetail idGuid={props.data.reelTypeIdGuid} />
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowReelTypeModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog>    
        <Box sx={{display:'flex'}}>
            <Typography variant="body2" sx={{fontWeight:'bold'}}>Serial Number:</Typography>
            {props.data.curReelSerialNumber!=null
            ?
            <Typography variant="body2" sx={{ml:'2px'}}>{props.data.curReelSerialNumber==null?null:props.data.curReelSerialNumber}</Typography>
            :
            <Typography variant="body2" sx={{ml:'2px'}}>None</Typography>
            }
        </Box>
        <Link onClick={(event) => {handleClick(event);}} sx={{textDecoration:'none', cursor:'pointer'}}>
            <Box sx={{display:'flex'}}>
                <Typography variant="body2" sx={{fontWeight:'bold'}}>Type:</Typography>
                <Typography variant="body2" sx={{ml:'2px'}}>{props.data.reelTypeName}</Typography>
            </Box>
        </Link>
        {props.data.curTrackerESN!=null
        ?
        <>
        <Box sx={{display:'flex'}}>
            <Typography variant="body2" sx={{fontWeight:'bold'}}>Tracker:</Typography>
            <Typography variant="body2" sx={{ml:'2px'}}>{props.data.curTrackerESN}</Typography>
        </Box>
        {props.data.status < 100
        ?
        <>
        <Box sx={{display:'flex'}}>
            <Typography variant="body2" sx={{fontWeight:'bold'}}>Battery Level:</Typography>
            <Typography variant="body2" sx={{ml:'2px'}}>{props.data.curTrackerBattery}</Typography>
            <Typography variant="body2">%</Typography>
        </Box>
        <Box sx={{display:'flex'}}>
        {
            props.data.trackerLastUpdateDays == null || props.data.curTrackerLastUpdate == null
            ?
            <>
            <Typography variant="body2" sx={{fontWeight:'bold'}}>Last Update:</Typography>
            <Typography variant="body2" sx={{ml:'2px', color:'red'}}>No Updates</Typography>
            </>
            :
            props.data.trackerLastUpdateDays <2 
            ?
            <>
            <Typography variant="body2" sx={{fontWeight:'bold'}}>Last Update:</Typography>
            <Typography variant="body2" sx={{ml:'2px', color:'green'}}>{formatObj.format(new Date(props.data.curTrackerLastUpdate))}</Typography>
            </>
            :
            props.data.trackerLastUpdateDays <3
            ?
            <>
            <Typography variant="body2" sx={{fontWeight:'bold'}}>Last Update:</Typography>
            <Typography variant="body2" sx={{ml:'2px', color:'gold'}}>{formatObj.format(new Date(props.data.curTrackerLastUpdate))}</Typography>
            </>
            :
            props.data.trackerLastUpdateDays <4
            ?
            <>
            <Typography variant="body2" sx={{fontWeight:'bold'}}>Last Update:</Typography>
            <Typography variant="body2" sx={{ml:'2px', color:'orange'}}>{formatObj.format(new Date(props.data.curTrackerLastUpdate))}</Typography>
            </>
            :
            props.data.trackerLastUpdateDays <5
            ?
            <>
            <Typography variant="body2" sx={{fontWeight:'bold'}}>Last Update:</Typography>
            <Typography variant="body2" sx={{ml:'2px', color:'red'}}>{formatObj.format(new Date(props.data.curTrackerLastUpdate))}</Typography>
            </>
            :
            <>
            <Typography variant="body2" sx={{fontWeight:'bold'}}>Last Update:</Typography>
            <Typography variant="body2" sx={{ml:'2px', color:'red'}}>{formatObj.format(new Date(props.data.curTrackerLastUpdate))}</Typography>
            </>
            }
        </Box>
        <Box sx={{display:'flex', alignItems:'center'}}>
            <Typography variant="body2" sx={{fontWeight:'bold'}}>Last Move:</Typography>
            {
            props.data.curLastLocationDT !== null
            ?
                <>
                <Typography variant="body2" sx={{ml:'2px', display:'flex', alignItems:'center'}}>{formatObj.format(new Date(props.data.curLastLocationDT))}</Typography>
                </>
            :
                <>
                <Typography variant="body2" sx={{ml:'2px', display:'flex', alignItems:'center'}}>Unknown</Typography>
                </>
            }
            <LoadListListItemReelLock data={props.data} />
        </Box> 
        <Box sx={{display:'flex'}}>
            <Typography variant="body2" sx={{fontWeight:'bold'}}>Days Stationary:</Typography>
            <Typography variant="body2" sx={{ml:'2px'}}>{props.data.daysStationary}</Typography>
        </Box>
        </>
        :
        ''
        }        
        </>
        :
        <>
        <Box sx={{display:'flex'}}>
            <Typography variant="body2" sx={{fontWeight:'bold'}}>Tracker:</Typography>
            <Typography variant="body2" sx={{ml:'2px', color:"red"}}>Not Tracked</Typography>
        </Box>
        {props.data.status < 100
        ?
        <>
        <Box sx={{display:'flex'}}>
            <Typography variant="body2" sx={{fontWeight:'bold'}}>Battery Level:</Typography>
            <Typography variant="body2" sx={{ml:'2px', color:"red"}}>Not Tracked</Typography>
        </Box>
        <Box sx={{display:'flex'}}>
            <Typography variant="body2" sx={{fontWeight:'bold'}}>Last Move:</Typography>
            <Typography variant="body2" sx={{ml:'2px', color:"red"}}>Not Tracked</Typography>
        </Box> 
        <Box sx={{display:'flex'}}>
            <Typography variant="body2" sx={{fontWeight:'bold'}}>Days Stationary:</Typography>
            <Typography variant="body2" sx={{ml:'2px', color:"red"}}>Not Tracked</Typography>
        </Box>
        </>
        :
        ''
        }        
        </>
        }
        <LoadListListItemReelInspection idGuid={props.data.reelInspectionIdGuid} name={props.data.reelInspectionName}/>
        <Box sx={{display:'flex'}}>
                {props.data.status < 100
                ?            
                <Typography variant="body2" sx={{fontWeight:'bold'}}>Deferral:</Typography>
                :
                ''
                }
            <Box>
                {props.data.deferralPeriod > 0
                ?
                    props.data.status < 100
                    ?
                    <>
                    <Box sx={{display:'flex'}}>
                        <Typography variant="body2" sx={{ml:'2px'}}>{props.data.deferralPeriod}</Typography>
                        <Typography variant="body2" sx={{ml:'2px'}}>Months</Typography>
                    </Box>
                    <Box sx={{display:'flex'}}>
                        {
                        props.data.deferralDaysLeft>90
                        ?
                        <>
                        <Typography variant="body2" sx={{ml:'2px', color:'green', fontWeight:'bold', fontSize:'1rem'}}>{props.data.deferralDaysLeft}</Typography>
                        <Typography variant="body2" sx={{ml:'2px', color:'green', fontWeight:'bold', fontSize:'1rem'}}>Days Remaining</Typography>
                        </>
                        :
                        props.data.deferralDaysLeft > 60
                        ?
                        <>
                        <Typography variant="body2" sx={{ml:'2px', color:'gold', fontWeight:'bold', fontSize:'1rem'}}>{props.data.deferralDaysLeft}</Typography>
                        <Typography variant="body2" sx={{ml:'2px', color:'gold', fontWeight:'bold', fontSize:'1rem'}}>Days Remaining</Typography>
                        </>
                        :
                        props.data.deferralDaysLeft > 30
                        ?
                        <>
                        <Typography variant="body2" sx={{ml:'2px', color:'orange', fontWeight:'bold', fontSize:'1rem'}}>{props.data.deferralDaysLeft}</Typography>
                        <Typography variant="body2" sx={{ml:'2px', color:'orange', fontWeight:'bold', fontSize:'1rem'}}>Days Remaining</Typography>
                        </>
                        :
                        props.data.deferralDaysLeft >= 0
                        ?
                        <>
                        <Typography variant="body2" sx={{ml:'2px', color:'red', fontWeight:'bold', fontSize:'1rem'}}>{props.data.deferralDaysLeft}</Typography>
                        <Typography variant="body2" sx={{ml:'2px', color:'red', fontWeight:'bold', fontSize:'1rem'}}>Days Remaining</Typography>
                        </>
                        :
                        <>
                        <Typography variant="body2" sx={{ml:'2px', color:'red', fontWeight:'bold', fontSize:'1rem'}}>{props.data.deferralDaysLeft*-1}</Typography>
                        <Typography variant="body2" sx={{ml:'2px', color:'red', fontWeight:'bold', fontSize:'1rem'}}>Days Overdue</Typography>
                        </>
                        }
                    </Box>
                    </>
                    :
                    ''
                :
                <>
                <Box sx={{display:'flex'}}>
                    <Typography variant="body2" sx={{ml:'2px'}}>No Deferral</Typography>
                </Box>
                <Box sx={{display:'flex'}}>
                    <Typography variant="body2" sx={{ml:'2px'}}>{props.data.deferralDaysLeft*-1}</Typography>
                    <Typography variant="body2" sx={{ml:'2px', color:'green'}}>Days On Site</Typography>
                </Box>
                </>
                }
            </Box>
        </Box>
    </>
    )
}

